import React from 'react';
import styled, { css } from 'styled-components';

const base = css`
  font-family: ${p => p.theme.fonts.mono};
  font-size: ${p => p.$size === 'lg' ? '0.85rem' : '0.72rem'};
  letter-spacing: 0.15em;
  color: ${p => p.$gold ? p.theme.colors.starGold : p.theme.colors.textMuted};
  text-transform: ${p => p.$upper ? 'uppercase' : 'none'};
`;

const Span = styled.span`${base}`;

/**
 * MonoCaption — モノスペースの小さなラベル / 座標 / 時刻
 *
 * <MonoCaption upper gold>2026 · 05 · 15</MonoCaption>
 */
const MonoCaption = ({ children, upper = false, gold = false, size = 'sm', ...rest }) => (
  <Span $upper={upper} $gold={gold} $size={size} {...rest}>
    {children}
  </Span>
);

export default MonoCaption;
